import gql from 'graphql-tag';

const apmsLocationListQuery = gql`
  query apmsLocationList(
    $name: String
    $page: Int
    $size: Int
    $active: Boolean
  ) {
    apmsLocationList(name: $name, page: $page, size: $size, active: $active) {
      id
      name
    }
  }
`;

export default apmsLocationListQuery;
